import API, {config} from './_main';
import {AxiosPromise} from 'axios';
import {Types} from "Modules/ContractModule";
import GetContractListResponse = Types.GetContractListResponse;
import GetContractHistoryResponse = Types.GetContractHistoryResponse;
import ChangeOffDateBody = Types.ChangeOffDateBody;
import EditContractBody = Types.EditContractBody;

export function getContractList(params?: URLSearchParams): AxiosPromise<GetContractListResponse> {
    return API.get('contract', config(params));
}

export function getContractHistory(contractId: number): AxiosPromise<GetContractHistoryResponse> {
    return API.get(`contract/${contractId}/history`);
}

export function putPlannedEndDate(id: number, formData: ChangeOffDateBody): AxiosPromise<GetContractHistoryResponse> {
    return API.put(`contract/${id}/planned-end-date`, formData);
}

export function editContract(formData: EditContractBody) {
    return API.post(`contract/change`, formData);
}



// WEBPACK FOOTER //
// ./src/Connectors/ContractConnector.ts